export default function Marquee({
  items = [],
  speed = "normal",
  reverse = false,
  className = "",
  separator = "✦",
  variant = "stroke", // 'stroke' | 'solid' | 'orange'
}) {
  const baseTextClass =
    variant === "stroke"
      ? "text-stroke"
      : variant === "orange"
      ? "text-[#FF4500]"
      : "text-white";

  const speedClass = speed === "fast" ? "ink-marquee-fast" : "";
  const dirClass = reverse ? "ink-marquee-reverse" : "";

  // Duplicate items so the loop is seamless
  const loop = [...items, ...items];

  return (
    <div
      className={`overflow-hidden whitespace-nowrap py-2 ${className}`}
      data-testid="marquee"
    >
      <div className={`ink-marquee ${speedClass} ${dirClass}`}>
        {loop.map((item, i) => (
          <span
            key={i}
            className={`font-display font-black uppercase tracking-tight text-5xl md:text-7xl lg:text-8xl ${baseTextClass}`}
          >
            {item}
            <span className="mx-10 text-white/20">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
